import { pathTranslations } from '../server/pathTranslations.js';

const CANONICAL_SLUG_TO_API_NAME: Record<string, string> = {
  'used-automation-equipment': 'automation-equipment',
  'used-machine-tools': 'machine-tool',
  'used-plastics-processing-machinery': 'plastics-processing',
  'used-sheet-metal-machinery': 'sheet-metal',
  'used-wood-working-machinery': 'wood-working',
};

const CATEGORY_SLUG_TO_API_NAME: Record<string, string> = {};

for (const canonicalPath in pathTranslations) {
  const canonicalSlug = canonicalPath.split('/').pop();
  if (canonicalSlug && CANONICAL_SLUG_TO_API_NAME[canonicalSlug]) {
    const apiName = CANONICAL_SLUG_TO_API_NAME[canonicalSlug];

    // Add the canonical slug itself
    CATEGORY_SLUG_TO_API_NAME[canonicalSlug] = apiName;

    const translations =
      pathTranslations[canonicalPath as keyof typeof pathTranslations];
    for (const locale in translations) {
      const translatedPath = translations[locale as keyof typeof translations];
      const translatedSlug = translatedPath?.split('/').pop();
      if (translatedSlug) {
        // Handle decoded URI components like in `/selling-process/step-3` for hr-HR
        const decodedSlug = decodeURIComponent(translatedSlug);
        CATEGORY_SLUG_TO_API_NAME[decodedSlug] = apiName;
      }
    }
  }
}

export { CATEGORY_SLUG_TO_API_NAME };
